import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import zhLocale from './zh'
import enLocale from './en'
Vue.use(VueI18n)

const messages = {
//   en: {
//     ...enLocale,
//     ...elementEnLocale
//   },
  zh: {
    ...zhLocale,

  },
  en:{
    ...enLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh
  locale: Cookies.get('language_system') || 'zh',
  // set locale messages
  messages
})

export default i18n
